/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconEyeMinus = createReactComponent("outline", "eye-minus", "IconEyeMinus", [["path", { "d": "M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0", "key": "svg-0" }], ["path", { "d": "M12 18c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6c-.713 1.188 -1.478 2.199 -2.296 3.034", "key": "svg-1" }], ["path", { "d": "M16 19h6", "key": "svg-2" }]]);

export { IconEyeMinus as default };
//# sourceMappingURL=IconEyeMinus.mjs.map
